import { getSupabase } from './client.js';
import { unwrap } from './errors.js';

export async function updateMyProfile(userId, { fullName, theme }) {
  const patch = {};
  if (fullName !== undefined) patch.full_name = fullName;
  if (theme !== undefined) patch.theme = theme;
  return unwrap(await getSupabase().from('profiles').update(patch).eq('id', userId).select('id, full_name, theme').single());
}
